'use client'

import { useRef } from 'react'
import { composeClasses } from '@wiggot/utils/src/strings'
import { usePrefetchOnHover } from './hooks/usePrefetchOnHover'
import { useHardNavigation } from './hooks/useHardNavigation'

interface Props {
  href: string
  children: React.ReactNode
  className?: string
  prefetch?: boolean
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

export default function HardLink({
  href,
  children,
  className,
  prefetch = true,
  onClick
}: Props) {
  const linkRef = useRef<HTMLAnchorElement>(null)

  usePrefetchOnHover(linkRef, href, prefetch)
  useHardNavigation(linkRef, href)

  return (
    <a
      ref={linkRef}
      href={href}
      data-hardlink
      className={composeClasses('hard-link', className)}
      onClick={onClick}
    >
      {children}
    </a>
  )
}
